import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 15l-3 -3l3 -3","key":"svg-0"}],["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-1"}]]

const IconSquareChevronLeft = createReactComponent('outline', 'square-chevron-left', 'SquareChevronLeft', __iconNode);

export default IconSquareChevronLeft;